module.exports = __webpack_public_path__ + "media/images/hitfun/welcome.socials.yandex-42d54ff8e6f7ffd2f2c7e198da3e63b0.svg";